import $http from '../../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Cargar la información del gre
 *
 * @param {*} productId: identificador del producto.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function getInformationGre({ commit }, productId) {
    commit('dashboard/load', true, { root: true });

    await $http.get(`nu-gres/products/emergency-response-guides/details/${productId}`)
        .then(({ data: response }) => commit('setGreInformation', response.data))
        .catch(() => {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Información del GRE.',
                text: 'Falla al tratar de cargar información del GRE por producto.',
                showConfirmButton: true,
            })
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}